export const LIST_PHOTOGRAPHER_UPLOAD_SUCCESS = 'LIST_PHOTOGRAPHER_UPLOAD_SUCCESS';
export const SAVE_PHOTOGRAPHER_UPLOAD_METADATA_SUCCESS =
    'SAVE_PHOTOGRAPHER_UPLOAD_METADATA_SUCCESS';
